import React from "react";
import { createRoot } from 'react-dom/client';
import "./css/index.css";
import App from "./js/App";
import * as serviceWorker from "./js/utils/serviceWorker";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
